import type { PrescriberAddressWithSupervisor } from '@truepill/tpos-types'
import { UserRoles } from '@truepill/tpos-types'
import AddressEntry from 'components/AddressEntry'
import Lozenge from 'components/Tiles/Lozenge'
import EditPracticeModal from 'modals/EditPracticeModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { usePlusClient } from 'providers/VisionRouter'
import { primaryColor, subduedColor } from 'styles/styleVariables'
import type { Prescriber } from 'types'
import { checkIfProvided, formatPhoneNumber } from 'utils'
import {
  StyledLink,
  PracticeName,
  PracticeAddress,
  PhoneNumber,
  FaxNumber,
  Spi,
  ServiceLevel,
  Status,
  PracticeAddressRow,
  SupervisingPhysician,
} from './StyledComponents'

type PracticeAddressEntryType = { address: PrescriberAddressWithSupervisor; prescriber: Prescriber; isVet: boolean }

const PracticeAddressEntry = ({ address, prescriber, isVet }: PracticeAddressEntryType): JSX.Element => {
  const { showModal } = useModalContext()
  const {
    tokenContext: { hasRole },
  } = usePlusClient()

  const canEditPractice = hasRole([
    UserRoles.Admin,
    UserRoles.Technician,
    UserRoles.Pharmacist,
    UserRoles.LeadPharmacist,
    UserRoles.CustomerSupport,
    UserRoles.LeadCustomerSupport,
  ])

  const handleRowClick = () => {
    if (canEditPractice) {
      showModal(() => <EditPracticeModal address={address} prescriber={prescriber} />)
    }
  }

  return (
    <StyledLink>
      <PracticeAddressRow onClick={handleRowClick} isArchived={address.isArchived}>
        <PracticeName>{address?.businessName}</PracticeName>
        <PracticeAddress>
          <AddressEntry inline address={address} />
        </PracticeAddress>
        <PhoneNumber>{checkIfProvided(formatPhoneNumber(address?.phone))}</PhoneNumber>
        <FaxNumber>{checkIfProvided(formatPhoneNumber(address?.fax))}</FaxNumber>
        <SupervisingPhysician>
          {address.supervisor?.firstName} {address.supervisor?.lastName}
        </SupervisingPhysician>
        {isVet ? '' : <Spi>{checkIfProvided(address?.spi)}</Spi>}
        {isVet ? '' : <ServiceLevel>{(address?.serviceLevel || []).join(', ')}</ServiceLevel>}
        {isVet ? (
          ''
        ) : (
          <Status>
            <Lozenge backgroundColor={address.isActive ? primaryColor : subduedColor}>
              {address.isActive ? 'ACTIVE' : 'INACTIVE'}
            </Lozenge>
          </Status>
        )}
      </PracticeAddressRow>
    </StyledLink>
  )
}

export default PracticeAddressEntry
